'use client';

import React, { useEffect, useRef } from 'react';

interface AdSenseAdProps {
    slotId?: string;
    width?: number;
    height?: number;
    format?: string;
    layout?: string;
    style?: React.CSSProperties;
    className?: string;
    responsive?: boolean;
    layoutKey?: string;
}

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        adsbygoogle: any[] & { loaded?: boolean };
    }
}

const AdSenseAd: React.FC<AdSenseAdProps> = ({
    slotId = '4002915412',
    width,
    height,
    format = 'auto',
    layout,
    layoutKey,
    style,
    className = '',
    responsive = true
}) => {
    const adRef = useRef<HTMLModElement>(null);

    useEffect(() => {
        const pushAd = () => {
            if (typeof window !== 'undefined' && adRef.current && !adRef.current?.getAttribute('data-ad-status')) {
                // Ensure adsbygoogle is defined
                window.adsbygoogle = window.adsbygoogle || [];

                try {
                    (window.adsbygoogle as any).push({});
                } catch (e) {
                    console.error('AdSense push error:', e);
                }
            }
        };

        // Standard delay for ads to ensure container size is ready
        const timer = setTimeout(pushAd, 300);
        return () => clearTimeout(timer);
    }, [slotId]);

    const defaultStyle: React.CSSProperties = {
        display: 'block',  // Changed from layout === 'in-article' ? 'block' : 'inline-block'
        textAlign: layout === 'in-article' ? 'center' : undefined,
        width: width ? `${width}px` : undefined,
        height: height ? `${height}px` : undefined,
        maxWidth: '100%',
        ...style
    };

    // if (process.env.NODE_ENV === 'development') {
    //     return (
    //         <div className={`flex justify-center my-6 ${className}`} style={{ ...defaultStyle, background: '#f0f0f0', border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    //             <span style={{ color: '#999', fontSize: '12px', fontWeight: 'bold' }}>ADVERTISEMENT (Dev Mode)</span>
    //         </div>
    //     );
    // }

    return (
        <div className={`flex justify-center my-6 overflow-hidden ${className}`}>
            <ins
                ref={adRef}
                className="adsbygoogle"
                style={defaultStyle}
                data-ad-client="ca-pub-8209081290130316"
                data-ad-slot={slotId}
                data-ad-format={format}
                data-ad-layout={layout}
                data-ad-layout-key={layoutKey}
                data-full-width-responsive={responsive}
            />
        </div>
    );
};

export default AdSenseAd;
